var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_c('sup',[_vm._v("© ")]),_c('span',{attrs:{"id":"year"}}),_vm._v(" "+_vm._s(_vm.Name)+". "+_vm._s(_vm.rights)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }